import { computed } from '@nuxtjs/composition-api';
import { useStore } from '~/composables/useStore';

export const useUuidEncryption = () => {
  const store = useStore();
  const authenticated = computed(() => store.state.auth.authenticated);

  const encryptUuid = async () => {
    if (!authenticated.value) return;
    try {
      const { hashes } = await store.dispatch('user/user/encryptUuid', {
        body: {
          data: store.state.user.info.userBase?.uuid || '',
        },
      });
      return hashes ? hashes[0] : undefined;
    } catch {
      // 何もしない
    }
  };

  return { encryptUuid };
};
